import Home from './pages/Home'
import JobPromptInput from './pages/JobPromptInput'
import Feedback from './pages/Feedback'
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import JobPost from './pages/JobPost'
import Premium from './pages/Premium'
import CandidateList from './pages/CandidateList'
import JobList from './pages/JobList'

export default function Router() {
    const Layout = () => {
        return (
            <>
            <div className="content"><Outlet /></div>
            </>
        )
    }

    const BrowserRoutes = () => {
        return (
            <BrowserRouter>
                <Routes>
                <Route path="/" element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="jobpost" element={<JobPost />} />
                    <Route path="jobpost-internal" element={<JobPromptInput />} />
                    <Route path="feedback/:id" element={<Feedback />} />
                    <Route path="premium" element={<Premium />} />
                    <Route path="candidatelist/:jobId" element={<CandidateList />} />
                    <Route path="joblist" element={<JobList />} />
                </Route>
                </Routes>
            </BrowserRouter>
        )
    }
    return (
        <BrowserRoutes />
    )
}